import { HEADER } from "@constants/images";
import { useState } from "react";
import HeaderItem from "@components/common/HeaderItem.component";
import { LOGOS } from "@constants/images";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const [showMenu, setShowMenu] = useState<boolean>(false);
  const navigate = useNavigate();

  return (
    <div className="header-container">
      <div className="header-wrapper">
        <div className="header-logo">
          <img
            onClick={() => navigate("/")}
            src={LOGOS.GANGSTAVERSE}
            alt="gangstaaverse-logo"
          />
        </div>
        <img
          onClick={() => {
            setShowMenu(!showMenu);
          }}
          className="header-burger"
          src={HEADER.BURGER}
        ></img>
      </div>
      {showMenu && <HeaderItem showMenu={showMenu} setShowMenu={setShowMenu} />}
    </div>
  );
};

export default Header;
